import { render, staticRenderFns } from "./TheBeni.vue?vue&type=template&id=139485d0&scoped=true"
import script from "./TheBeni.vue?vue&type=script&lang=ts"
export * from "./TheBeni.vue?vue&type=script&lang=ts"
import style0 from "./TheBeni.vue?vue&type=style&index=0&id=139485d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139485d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowDetailsTheAttachmentBtn: require('/usr/src/nuxt-app/components/show/details/TheAttachmentBtn.vue').default,ShowTabsDettaglioLottoTheMap: require('/usr/src/nuxt-app/components/show/tabs/dettaglioLotto/TheMap.vue').default})
